import React, { useState } from 'react';
import { showFirst12Words, showFirst22Words } from '../helper/showFirstSixWords';
import { whiteCard } from '../common/cssclasses';
import { getFileName } from '../helper/getFileName';
import PdfViewerPopup from './pdf/PdfViewerPopup';

export default function LibraryCard({ index, item }) {
    const hasLink = !!item?.content;
    const [openPopup, setOpenPopup] = useState(false);

    return (
        <>
            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 mb-main" key={index}
                onClick={() => {
                    if (hasLink) {
                        setOpenPopup(true);
                    }
                }}
                style={{ position: "relative", cursor: hasLink ? "pointer" : "" }}>
            <div className={whiteCard}>
                <div className='row h-100'>
                    <div style={{ position: 'relative' }}>
                        <div className='w-100 position-relative mb-form-group'>
                            <div>
                                <img src={item?.image} alt={getFileName(item?.image)} className="w-100 border-15" style={{ height: 430 }} />
                            </div>
                        </div>
                    </div>
                    <>
                        <div className="horseCardTitle mb-1">{showFirst12Words(item?.title)}</div>
                        {!!item?.subtitle &&
                            <p className="horseCardDescription fw-bold mb-2 ">{showFirst22Words(item?.subtitle)}</p>
                        }
                        <div className="w-100 d-flex justify-content-between align-items-center mt-auto pt-2">
                            <div>
                                {!!item?.dipslayDate?.[2] && (
                                    <div className="newsPageNewsDay">{item?.dipslayDate[2]}</div>
                                )}
                            </div>
                        </div>
                    </>
                </div>
            </div>
            </div>
            <PdfViewerPopup 
                open={openPopup}
                onClose={() => setOpenPopup(false)}
                title={item?.title}
                attachmentUrl={item?.content}
                canDownloadContent={item?.canDownloadContent}
            />
        </>
    )
}
